import { P2GAlert, P2GText, SvgCalendarOneDay } from '@parcel2go/core-ui';
import { CollectionDateApiModel } from '~/lib/api/smartsend/types';
import ItemCollectionDate from './item/ItemCollectionDate';
import SidePanelSection from '../../../../components/sidepanel-section';
import { Fragment } from 'react/jsx-runtime';
import { TranslationNamespaces } from '~/lib/constants';
import { useTranslation } from 'react-i18next';

interface props {
  onUpdate: (date: Date) => void;
  title?: string;
  dates: CollectionDateApiModel[];
  selected: Date;
  variant?: 'body2';
}

export const ItemCollectionDateSection: React.FC<props> = (props) => {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  const icon = { icon: <SvgCalendarOneDay />, path: '/theme/icons/CalendarOneDay.svg' };
  return (
    <SidePanelSection title={props.title}>
      <P2GAlert palette="primary" icon={icon?.icon}>
        <Fragment key={`${props.selected}`}>
          <P2GText variant={props.variant}>
            {t('PREFERRED_COLLECTION_DATE', { defaultValue: 'Your preferred collection date is:' })}
          </P2GText>{' '}
          <ItemCollectionDate
            dateSize="large"
            hideHeader={true}
            variant={props.variant}
            dates={props.dates}
            selected={props.selected}
            setDate={props.onUpdate}
          />
        </Fragment>
      </P2GAlert>
    </SidePanelSection>
  );
};
